export const navSections = [
  { id: "lead", label: "本期要闻", key: "lead" },
  { id: "faces", label: "新涉事者", key: "faces" },
  { id: "stream", label: "快讯流", key: "stream" },
  { id: "deep", label: "事件还原", key: "deep" },
  { id: "rank", label: "热议榜", key: "rank" },
];

export const edition = {
  issue: "第 018 期",
  date: "2026.09.09",
  weekday: "星期三",
  blurb: "本期共收录新涉事者 9 位、时间线快讯 24 条，为近期人物与争议提供一份可检索的背景档案。",
};

export const lead = {
  kicker: "本期封面 · 新涉事者聚焦",
  headline: "风口浪尖上，谁是新一批被重新读档的近期人物",
  dek: "当旧闻变成新料，背景梳理比爆料本身更先发生。本周我们以「卷入—回应—演变」为线索，还原几位首次进入舆论中心的当事人如何在 72 小时内完成立场迁移。",
  tag: "事件还原 · 专题",
  author: "编辑部 · 资料组",
  minutes: "12 分钟深度",
  image: "https://readdy.ai/api/search-image?query=Dark%20editorial%20night%20cityscape%20with%20distant%20office%20towers%20and%20warm%20crimson%20hazard%20bokeh%20lights%20in%20motion%2C%20moody%20cinematic%20high%20contrast%2C%20deep%20charcoal%20and%20subtle%20red%20accents%2C%20grainy%20film%20texture%2C%20atmospheric%20and%20abstract%2C%20no%20text%2C%20editorial%20magazine%20cover%20tone&width=1200&height=760&seq=hz-lead-01&orientation=landscape",
};

export const sideCards = [
  {
    tag: "新涉事者",
    title: "被一张旧截图重新带进风浪的「前员工」",
    snippet: "同一张对话记录的两种口径，谁先提供了完整上下文？",
    time: "36 分钟前",
    image: "https://readdy.ai/api/search-image?query=Dimly%20lit%20desk%20with%20scattered%20documents%20and%20a%20smartphone%20screen%20glow%2C%20shallow%20depth%20of%20field%2C%20warm%20dark%20charcoal%20tones%20with%20crimson%20accent%20lighting%2C%20moody%20documentary%20photography%2C%20high%20contrast%2C%20grainy%2C%20no%20text&width=640&height=420&seq=hz-side-01&orientation=landscape",
  },
  {
    tag: "事件还原",
    title: "这场「自证清白」发布会，回应的其实是三周前的旧账",
    snippet: "发布会的问与答之间，藏着一段未对外披露的时间差。",
    time: "1 小时前",
    image: "https://readdy.ai/api/search-image?query=Blurred%20press%20conference%20stage%20with%20rows%20of%20microphones%20silhouetted%20against%20warm%20red%20backlight%2C%20crowd%20out%20of%20focus%2C%20cinematic%20high%20contrast%2C%20charcoal%20and%20crimson%20palette%2C%20documentary%20editorial%20mood%2C%20no%20text&width=640&height=420&seq=hz-side-02&orientation=landscape",
  },
  {
    tag: "争议追踪",
    title: "「冷处理」和「硬刚」之间，还隔着一条没有回应的评论",
    snippet: "当事人沉默的空窗期，往往是背景梳理密度最高的时段。",
    time: "2 小时前",
    image: "https://readdy.ai/api/search-image?query=Close%20up%20of%20dark%20wooden%20desk%20with%20muted%20newspaper%20sheets%20and%20pen%2C%20warm%20side%20lighting%2C%20deep%20shadow%2C%20charcoal%20gray%20with%20soft%20amber%20highlight%2C%20editorial%20still%20life%2C%20high%20contrast%2C%20grainy%20film%2C%20no%20text&width=640&height=420&seq=hz-side-03&orientation=landscape",
  },
];

export const hotRank = [
  { rank: 1, persona: "沈屿（科技创投）", tag: "融资明细遭逐条比对", heat: 9821, delta: "+412", trend: "up" },
  { rank: 2, persona: "蒋闻（综艺监制）", tag: "片酬账目与片场旧账并线", heat: 8745, delta: "+208", trend: "up" },
  { rank: 3, persona: "祁梵（品牌主理人）", tag: "代言边界与私下言论同屏", heat: 7632, delta: "-115", trend: "down" },
  { rank: 4, persona: "方砚（私募合伙人）", tag: "一桩三年前的结构化产品再被翻出", heat: 6988, delta: "+337", trend: "up" },
  { rank: 5, persona: "陆棠（主播）", tag: "连麦记录被剪辑后二次传播", heat: 5310, delta: "+92", trend: "up" },
  { rank: 6, persona: "郑迟（制片人）", tag: "项目分红比例争议延烧", heat: 4877, delta: "-204", trend: "down" },
  { rank: 7, persona: "叶蘅（创始人）", tag: "对赌条款披露口径不一致", heat: 4106, delta: "+61", trend: "up" },
  { rank: 8, persona: "贺屿森（职业经理人）", tag: "离任声明与年报表述互为对照", heat: 3654, delta: "-88", trend: "down" },
];

export const liveStream = [
  { time: "09:41", label: "新涉事者", tag: "首发", text: "某明星经纪公司前商务负责人进入公众视野，其公开的长文列出四组项目收支时间线，称愿配合核对。", field: "文娱" },
  { time: "08:56", label: "证据比对", tag: "跟进", text: "科技创投圈一份尽调纪要流出，页码与扫描日期被逐帧比对，网上出现「版本 v1 / v2」两种口径。", field: "财经" },
  { time: "08:12", label: "回应窗口", tag: "快讯", text: "涉事主播团队回应称连麦内容系「断章」，并晒出 40 分钟完整录屏链接，随后该链接一度访问拥堵。", field: "社媒" },
  { time: "07:30", label: "争议发酵", tag: "新料", text: "一款理财类产品的底层投向被重新整理成图表，此前标注的「稳健」字样引发反复讨论。", field: "财经" },
  { time: "06:48", label: "当事人发声", tag: "回应", text: "制片人郑迟首度以书面形式回应分红争议，指「比例非个人单方决定」，并呼吁以立项协议为准。", field: "文娱" },
  { time: "05:59", label: "资料还原", tag: "背景", text: "有博主将某品牌主理人三年前的采访剪成合辑，与今日代言声明并置，话题登上同城热搜。", field: "社媒" },
];

export const faces = [
  {
    name: "沈屿",
    role: "科技创投 · 管理合伙人",
    tags: ["融资明细", "尽调纪要", "首度发声"],
    intro: "此前极少进入公众讨论，因一份被逐条比对的融资表首次站到舆论台前。背景梳理显示其名下基金近两年转向硬科技方向。",
    heat: 87,
    watch: "已追踪 6 天",
    image: "https://readdy.ai/api/search-image?query=Backlit%20silhouette%20of%20a%20person%20in%20a%20business%20blazer%20against%20a%20deep%20charcoal%20background%20with%20subtle%20crimson%20rim%20light%2C%20anonymous%20and%20moody%2C%20high%20contrast%2C%20editorial%20documentary%20photography%2C%20grainy%20film%2C%20face%20unrecognizable%2C%20no%20text&width=600&height=680&seq=hz-face-01&orientation=portrait",
  },
  {
    name: "蒋闻",
    role: "综艺监制 · 从业十一年",
    tags: ["片酬账目", "片场旧账", "多线并案"],
    intro: "由「项目回报率被质疑」逐步延展至既往合作方的片场回忆，多线信息首次在时间轴上并置，形成相互印证。",
    heat: 79,
    watch: "已追踪 4 天",
    image: "https://readdy.ai/api/search-image?query=Side%20profile%20silhouette%20of%20a%20person%20holding%20a%20clipboard%20near%20a%20dark%20studio%20set%2C%20anonymous%20shadow%20figure%2C%20charcoal%20tones%20with%20warm%20amber%20backlight%2C%20cinematic%20high%20contrast%2C%20documentary%20mood%2C%20grainy%2C%20no%20text&width=600&height=680&seq=hz-face-02&orientation=portrait",
  },
  {
    name: "祁梵",
    role: "品牌主理人 · 出海服饰",
    tags: ["代言边界", "私下言论", "同屏对照"],
    intro: "一次面向海外渠道的内部说明被回传，公开声明的措辞与三年前采访的旧立场被放在同一时间线比读。",
    heat: 71,
    watch: "已追踪 3 天",
    image: "https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20person%20checking%20a%20phone%20in%20front%20of%20a%20dark%20retail%20window%20with%20warm%20red%20neon%20reflection%2C%20anonymous%2C%20charcoal%20and%20crimson%2C%20cinematic%20high%20contrast%2C%20moody%20documentary%2C%20grainy%2C%20no%20text&width=600&height=680&seq=hz-face-03&orientation=portrait",
  },
  {
    name: "方砚",
    role: "私募合伙人 · 专注一级市场",
    tags: ["结构化产品", "三年前", "再被翻出"],
    intro: "一桩三年前已结清的结构化产品因底层投向图表重登台前，当事人未置评，但其履历页悄然更新两处表述。",
    heat: 66,
    watch: "已追踪 2 天",
    image: "https://readdy.ai/api/search-image?query=Anonymous%20person%20in%20a%20suit%20silhouette%20facing%20a%20large%20dark%20glass%20window%20at%20night%2C%20reflective%20and%20moody%2C%20charcoal%20with%20faint%20crimson%20glow%2C%20cinematic%2C%20high%20contrast%2C%20documentary%20tone%2C%20no%20text&width=600&height=680&seq=hz-face-04&orientation=portrait",
  },
  {
    name: "陆棠",
    role: "财经主播 · 连麦常客",
    tags: ["连麦记录", "剪辑二次传播", "完整录屏"],
    intro: "一段被二次剪辑的连麦记录迅速扩散，团队以完整录屏回应。剪与未剪之间，正是背景梳理要补全的空缺。",
    heat: 58,
    watch: "已追踪 1 天",
    image: "https://readdy.ai/api/search-image?query=Silhouette%20of%20a%20person%20at%20a%20dark%20broadcast%20desk%20with%20a%20small%20ring%20light%2C%20anonymous%20talking%20figure%2C%20deep%20shadow%2C%20charcoal%20tones%20with%20soft%20amber%20glow%2C%20cinematic%20high%20contrast%2C%20no%20text&width=600&height=680&seq=hz-face-05&orientation=portrait",
  },
  {
    name: "叶蘅",
    role: "社区电商 · 创始人",
    tags: ["对赌条款", "口径差异", "密集回应"],
    intro: "对赌条款在招股、访谈与记者追问三处口径不一致，成为本轮争议的支点。当事人团队已连续回应三轮。",
    heat: 52,
    watch: "已追踪 1 天",
    image: "https://readdy.ai/api/search-image?query=Anonymous%20young%20person%20in%20casual%20blazer%20silhouette%20against%20a%20dark%20warehouse%20aisle%20with%20amber%20shelf%20lighting%2C%20moody%2C%20charcoal%20and%20warm%20amber%2C%20cinematic%20documentary%2C%20high%20contrast%2C%20no%20text&width=600&height=680&seq=hz-face-06&orientation=portrait",
  },
];

export const deepDive = {
  sectionLabel: "事件还原 · 长读档案",
  kicker: "多信源交叉 · 时间轴还原",
  title: "一条回应的 72 小时：从「沉默窗口」到「版本之争」",
  dek: "我们把一次典型争议拆成可核查的段落：什么时间出了什么信息、谁先引用、哪一段最缺上下文。还原不是站队，而是让每一步都有据可查。",
  columns: [
    { heading: "D0 · 卷入", body: "爆料的源头是一份带页码的扫描件，从项目群聊流出。当日转发量破万，但多数转发只截取了结论段，前提条件被省略。" },
    { heading: "D1 · 回应", body: "当事人团队先以短声明「正在核实」，随后在晚间发布会补充了时间差说明。对照原始文件，会中引用的两处数字与实际页码存在差异，成为第二波讨论。" },
    { heading: "D2 · 演变", body: "舆论重心从「事实对错」滑向「口径谁更可信」。我们按最小单元重排了 D0–D2 共 14 条关键信息，供读者自行对照，而非给出单一结论。" },
  ],
  foot: "注：所有线索均已标注来源时点与版本，正文不预设立场；事件最新进展请以当事人正式渠道为准。",
  image: "https://readdy.ai/api/search-image?query=Dark%20editorial%20flat%20lay%20of%20old%20paper%20documents%2C%20photographs%20and%20a%20mechanical%20typewriter%20on%20a%20charcoal%20desk%2C%20warm%20red%20and%20amber%20cross%20lighting%2C%20deep%20shadows%2C%20investigative%20mood%2C%20cinematic%20high%20contrast%2C%20grainy%20film%20texture%2C%20no%20text&width=1400&height=760&seq=hz-deep-01&orientation=landscape",
};

export const sectors = [
  { key: "fin", name: "财经与创投", count: "今日新涉事者 4 位", blurb: "融资、对赌、产品底层投向与尽调口径的逐项比对。" },
  { key: "ent", name: "文娱与制片", count: "今日新涉事者 3 位", blurb: "片酬账目、分红比例与项目回报的旧账并线追踪。" },
  { key: "soc", name: "社媒与直播", count: "今日新涉事者 2 位", blurb: "连麦、截图与完整录屏之间的剪与未剪。" },
  { key: "corp", name: "企业与职业人", count: "今日新涉事者 1 位", blurb: "离任声明、履历更新与年报表述的相互印证。" },
];

export const downloadPoints = [
  "快讯流实时更新，不错过背景梳理的关键时点",
  "新涉事者建立独立档案页，方便按人回看",
  "长读还原支持离线缓存，通勤时也能读完整条线",
];

export const footerLinks = [
  { head: "关于我们", items: ["编辑部介绍", "信息来源与立场", "内容纠错通道", "合作与入驻"] },
  { head: "阅读指南", items: ["如何阅读时间线", "口径与版本说明", "争议术语表", "推送设置"] },
  { head: "用户服务", items: ["电子周刊订阅", "客户端下载", "意见反馈", "联系方式"] },
];